<app-selected-leads-map />
<app-selected-lead-list style="padding-bottom: 50px" />
